import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'content'
})``;

export const TabHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 24px;

  h1 {
    flex: 1;
  }

  p {
    flex: 1;
    color: rgba(22,20,20,.2);
  }
`

export const ModalContainer = styled(Container)`
  justify-content: space-between;
  align-items: center;
  button {
    width: 100%;
  }
`;


export const FormGroupLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  & > div {
    margin: 0;
    &:not(:first-child) {
      margin-left: 12px;
    }
  }
`;
